import React from 'react';
import { func, string } from 'prop-types';

import Button from 'ravenjs/lib/Button';
import { genID } from 'ravenjs/utils/generate';

import { accessControl } from 'modules/acl';

const SidebarButton = ({ label, onClick, ...restProps }) => {
    return (
        <Button {...restProps} key={genID()} width="100%" onClick={onClick}>
            {label}
        </Button>
    );
};

SidebarButton.propTypes = {
    label: string.isRequired,
    onClick: func.isRequired,
};

export { SidebarButton as SidebarButtonUnwrapped };
export default accessControl(SidebarButton);
